import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["active", "ariaCurrent", "children", "className", "content", "href", "render"];

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import classNames from 'classnames';
import React from 'react';

function defaultRender(props) {
  var children = props.children,
      unhandledProps = props.unhandledProps,
      className = props.className,
      active = props.active;
  var baseStyles = /*#__PURE__*/css({
    color: '#77818f',
    fontWeight: active ? 400 : 'normal',
    fontSize: '14px',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: '18px',
    letterSpacing: 'normal',
    textDecoration: 'none',
    transition: 'color 0.2s ease-out',
    '&:link': {
      color: '#77818f'
    },
    '&:active': {
      color: '#77818f'
    },
    '&:visited': {
      color: '#77818f'
    },
    '&:hover': {
      color: '#4d5866'
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:baseStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

  if (active) {
    return jsx("span", _extends({}, unhandledProps, {
      className: className,
      css: baseStyles
    }), children);
  }

  return jsx("a", _extends({}, unhandledProps, {
    className: className,
    css: baseStyles
  }), children);
}

var BreadcrumbsLink = function BreadcrumbsLink(_ref) {
  var active = _ref.active,
      _ref$ariaCurrent = _ref.ariaCurrent,
      ariaCurrent = _ref$ariaCurrent === void 0 ? 'location' : _ref$ariaCurrent,
      children = _ref.children,
      className = _ref.className,
      content = _ref.content,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? '#' : _ref$href,
      _ref$render = _ref.render,
      render = _ref$render === void 0 ? defaultRender : _ref$render,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  var handledProps = {
    className: classNames(className)
  };

  if (active) {
    handledProps['aria-current'] = ariaCurrent;
  } else {
    handledProps.href = href;
  }

  var injectedChildren = children != null ? children : content;
  var injectedProps = {
    children: injectedChildren,
    className: handledProps.className,
    active: active,
    unhandledProps: _objectSpread(_objectSpread({}, unhandledProps), handledProps)
  };
  return render(injectedProps);
};

BreadcrumbsLink.displayName = 'BreadcrumbsLink';
export default BreadcrumbsLink;